//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum CatalogVariantComposition {
	None = 0,
	AutoAppend = 1,
	FixedWithInterval = 2
}
